import { CustomBreadcrumb, PageContent } from "components/Common";
import { ModuleIds } from "constant";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import InstrumentExpression from "./InstrumentExpression";

const RESOURCE = ModuleIds.Instrument
const InstrumentExpressionContainer = ({ t }) => {
    const titleTag = `Instruments`
    return (
        <PageContent title={titleTag}>
            <CustomBreadcrumb
                breadcrumbItem={t("Instrument")}
                resource={RESOURCE}
            />
            <InstrumentExpression />
        </PageContent>
    );
}

InstrumentExpressionContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["machinePage"])(InstrumentExpressionContainer)